import { render, staticRenderFns } from "./EmployeeSalary.vue?vue&type=template&id=957c2b56&"
import script from "./EmployeeSalary.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports